import gql from 'graphql-tag';

const GET_ACCOUNT_MESSAGE_CREDITS = gql`
  query GetAccountMessageCredits($accountId: Int!) {
    getAccountMessageCredits(account_id: $accountId) {
      limit
      used
      remaining
      resetDate
      nextResetDate
      percentageUsed
    }
  }
`;

export default GET_ACCOUNT_MESSAGE_CREDITS;